export const version = '3.672.1'
